import PropTypes from 'prop-types';

function DateWithLine({ children }) {
  return (
    <div className="date-with-line">
      <span className="date">{children}</span>
      <hr className="date-line" />
    </div>
  );
}

DateWithLine.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DateWithLine;
